import { h, render, hydrate } from 'preact';
import './styles/main.scss';
import { MegaOfficeSuppliesPage } from './pages/MegaOfficeSuppliesPage';
const mountElement = document.getElementById('search-app');
if (mountElement) {
    if (mountElement.hasChildNodes()) {
        hydrate(h(MegaOfficeSuppliesPage, null), mountElement);
    }
    else {
        render(h(MegaOfficeSuppliesPage, null), mountElement);
    }
}
